<script setup lang="ts">
import type { ReportImageStatus } from "@/types/report-images.types";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    status: ReportImageStatus;
    showLabel?: boolean;
    size?: "sm" | "md";
  }>(),
  {
    showLabel: false,
    size: "sm",
  },
);

const statusConfig = computed(() => {
  switch (props.status) {
    case "UNPROCESSED":
      return {
        label: "report:photos.status.unprocessed",
        colorClass: "status-unprocessed",
        icon: "bi-clock",
      };
    case "SORTED":
      return {
        label: "report:photos.status.sorted",
        colorClass: "status-sorted",
        icon: "bi-folder-check",
      };
    case "PLACED":
      return {
        label: "report:photos.status.placed",
        colorClass: "status-placed",
        icon: "bi-check-circle-fill",
      };
    case "EXCLUDED":
      return {
        label: "report:photos.status.ignored",
        colorClass: "status-ignored",
        icon: "bi-eye-slash-fill",
      };
    default:
      return {
        label: "",
        colorClass: "status-unprocessed",
        icon: "bi-question-circle",
      };
  }
});
</script>

<template>
  <span
    class="status-badge d-inline-flex align-items-center gap-1 rounded-pill"
    :class="[statusConfig.colorClass, `size-${size}`]"
  >
    <el-icon :size="size === 'sm' ? 10 : 12"
      ><i :class="statusConfig.icon"></i
    ></el-icon>
    <span v-if="showLabel" class="status-label">{{
      $t(statusConfig.label)
    }}</span>
  </span>
</template>

<style lang="scss" scoped>
.status-badge {
  font-weight: 500;
  white-space: nowrap;

  &.size-sm {
    padding: 2px 6px;
    font-size: 10px;
  }

  &.size-md {
    padding: 4px 10px;
    font-size: 12px;
  }
}

.status-unprocessed {
  background-color: #f3f4f6;
  color: #6b7280;
}

.status-sorted {
  background-color: #dbeafe;
  color: #1d4ed8;
}

.status-placed {
  background-color: #dcfce7;
  color: #15803d;
}

.status-ignored {
  background-color: #f3f4f6;
  color: #9ca3af;
}
</style>
